import React, { useState, useCallback, useEffect } from 'react';
import { Space, Table, Checkbox, Button, Modal, Form, Popconfirm, notification } from 'antd';
import {
    globalDeviceSearch, globalDeviceUpdate, globalDeviceCreate,
    globalDeviceBatchDelete, batchImportGlobalDevices,
} from '../../../api/device';
import Filter from './Filter'
import { textRender } from '../../../utils';
import Update from './Update';
import IfNotObserver from '../../common/IfNotObserver';
import UploadFile from '../../Project/UploadFile';
import { downloadFile } from '../../../utils';
import { apis } from '../../../constants';
const { Column } = Table;


const Devices: React.FC = () => {
    const [params, setParams] = useState<Partial<Omit<GlobalDeviceSearchParams, 'pageNum' | 'pageSize'>>>({
        type: '4G'
    });
    const [pagination, setPagination] = useState<Pick<SearchLogParams, 'pageNum' | 'pageSize'>>({
        pageNum: 1,
        pageSize: 10,
    });
    const [selectedRows, setSelectedRows] = useState<GlobalDevice[]>([]);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [updatingRecord, setUpdatingRecord] = useState<Partial<GlobalDevice>>();
    const isUpdate = !!updatingRecord?.deviceSn;
    const [data, setData] = useState<PagedData<GlobalDevice>>({
        pageNum: 1,
        pageSize: 10,
        total: 0,
        data: [],
    });
    const fetchData = useCallback(() => {
        setLoading(true);
        globalDeviceSearch({ ...params, ...pagination })
            .then(setData)
            .finally(() => { setLoading(false) });
    }, [params, pagination]);

    useEffect(fetchData, [fetchData]);
    const [deletingRecord, setDeletingRecord] = useState<GlobalDevice>();
    const [batchDeleting, setBatchDeleting] = useState(false);
    const [showBatchImportModal, setShowBatchImportModal] = useState(false);
    const [upserting, setUpserting] = useState(false);
    const [currentSelectedMac, setCurrentSelectedMac] = useState('');
    useEffect(() => {
        if (selectedRows.length === 0) {
            setCurrentSelectedMac('')
        }
    }, [selectedRows])
    useEffect(() => {
        form.setFieldsValue(updatingRecord)
    }, [updatingRecord]);
    const [selectedFile, setSelectedFile] = useState<any>();
    const [uploading, setUploading] = useState(false);

    return (
        <>
            <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Filter values={params} onChange={setParams} onSearch={fetchData} />
                <IfNotObserver>
                    <div style={{ marginTop: '1.4em' }}>
                        <Button style={{ margin: '0 1em' }} onClick={() => {
                            setShowBatchImportModal(true)
                        }} type='primary'>批量导入</Button>
                        <Button onClick={() => {
                            setUpdatingRecord({});
                        }} type='primary'>创建设备</Button>
                    </div>

                </IfNotObserver>
            </Space>
            <Popconfirm title='确定删除?' onConfirm={() => {
                setBatchDeleting(true)
                globalDeviceBatchDelete({ devSnList: selectedRows.map(i => i.deviceSn) })
                    .then(() => {
                        notification.success({ message: '删除成功' });
                        setPagination({
                            ...pagination,
                            pageNum: 1
                        });
                        setBatchDeleting(false);
                        setSelectedRows([]);
                    })
                    .catch((err: any) => {
                        setBatchDeleting(false)
                        notification.error({ message: err.message || '删除失败, 请重试' })
                    })
            }}>
                <Button loading={batchDeleting} danger style={{ paddingLeft: 0 }} disabled={!selectedRows.length} type='link'>批量删除{selectedRows.length ? `(${selectedRows.length})` : ''}</Button>
            </Popconfirm>

            <Modal
                title={isUpdate ? '编辑设备' : '创建设备'}
                open={!!updatingRecord}
                destroyOnClose
                footer={null}
                onCancel={() => {
                    setUpdatingRecord(undefined)
                }}
            >
                <Update form={form} isEdit={isUpdate} initialValues={updatingRecord} />
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button loading={upserting} type='primary' onClick={() => {
                        form.validateFields()
                            .then((values) => {
                                setUpserting(true)
                                if (!isUpdate) {
                                    globalDeviceCreate(values)
                                        .then(() => {
                                            setUpserting(false)
                                            setPagination({ ...pagination })
                                            setUpdatingRecord(undefined)
                                        })
                                        .catch((err) => {
                                            notification.error({
                                                message: err.message ||
                                                    `${isUpdate ? '更新' : '创建'}失败, 请重试`
                                            })
                                            setUpserting(false)
                                        })
                                } else {
                                    globalDeviceUpdate(updatingRecord?.deviceSn as string, values)
                                        .then(() => {
                                            setUpserting(false)
                                            setPagination({ ...pagination })
                                            setUpdatingRecord(undefined)
                                        })
                                        .catch((err) => {
                                            notification.error({
                                                message: err.message ||
                                                    `${isUpdate ? '更新' : '创建'}失败, 请重试`
                                            })
                                            setUpserting(false)
                                        })
                                }
                            })
                            .catch(err => { })
                    }}>确认{isUpdate ? '更新' : '创建'}</Button>
                </div>
            </Modal>
            <Modal title='批量导入' open={showBatchImportModal} destroyOnClose footer={null} onCancel={() => setShowBatchImportModal(false)}>
                <div>
                    <UploadFile onFileChange={(file) => {
                        setSelectedFile(file)
                    }} onDownloadTemplate={() => {
                        downloadFile(apis.globalDevicesTemplate);
                    }} />
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Button type='primary' loading={uploading} disabled={!selectedFile} onClick={() => {
                            const data = new FormData();
                            data.append('file', selectedFile);
                            setUploading(true)
                            batchImportGlobalDevices(data)
                                .then(res => {
                                    notification.success({
                                        message: '导入成功'
                                    });
                                    setUploading(false);
                                    setSelectedFile(undefined);
                                    setPagination({
                                        ...pagination,
                                        pageNum: 1,
                                    });
                                    setShowBatchImportModal(false)
                                })
                                .catch(err => {
                                    setUploading(false)
                                    notification.error({
                                        message: err.message || '导入失败,请重试'
                                    })
                                })

                        }}>确认</Button>
                    </div>
                </div>
            </Modal>
            <Table
                scroll={{ x: 1 }}
                rowSelection={{
                    renderCell(checked, record, index, originNode) {
                        return originNode
                    },
                    onSelect(row) {
                        setCurrentSelectedMac(row.mac);
                    },
                    selectedRowKeys: selectedRows.map(i => i.deviceSn),
                    onChange(_, selectedRows) {
                        setSelectedRows(selectedRows)
                    },
                }}
                pagination={{
                    pageSize: pagination.pageSize,
                    current: pagination.pageNum,
                    total: data.total,
                    onChange: (pageNum, pageSize) => {
                        setPagination({
                            ...pagination,
                            pageSize,
                            pageNum
                        })
                    }
                }}
                dataSource={Array.isArray(data.data) ? data.data : []} loading={loading}
                rowKey={'deviceSn'}
            >
                <Column title="设备序列号" dataIndex="deviceSn" key="deviceSn" />
                <Column title="ICCID" render={textRender} dataIndex="iccid" key="iccid" />
                <Column title="MAC地址" render={textRender} dataIndex="mac" key="mac" />
                {/* <Column title="展位号" render={textRender} dataIndex="name" key="name" /> */}
                {/* <Column title="网络类型" dataIndex="type" key="type" /> */}
                <Column title="操作" dataIndex="deviceSn" key="deviceSn" render={(_, row: GlobalDevice) => {
                    return <IfNotObserver>
                        <Button style={{ paddingLeft: 0 }} type='link' onClick={() => setUpdatingRecord({ ...row } as GlobalDevice)}>编辑</Button>
                        <Popconfirm title='确定删除?' onConfirm={() => {
                            setDeletingRecord(row)
                            globalDeviceBatchDelete({ devSnList: [row.deviceSn] })
                                .then(() => {
                                    setPagination({
                                        ...pagination,
                                        pageNum: 1
                                    });
                                    setDeletingRecord(undefined)
                                    notification.success({ message: '删除成功' })
                                })
                                .catch((err: any) => {
                                    notification.error({ message: err.message || '删除失败, 请重试' })
                                    setDeletingRecord(undefined)
                                })
                        }}>
                            <Button type='link' loading={deletingRecord?.deviceSn === row.deviceSn}>删除</Button>
                        </Popconfirm>
                    </IfNotObserver>
                }} />
            </Table>
        </>
    );
}

export default Devices;